import { State, TagsMap } from '@/studio/tags/store';

const mutations = {
  setTags(state: State, tags: TagsMap) {
    state.tags = tags;
  },
  setIsFetchingTags(state: State, isFetchingTags: boolean) {
    state.isFetchingTags = isFetchingTags;
  },
  setErrorFetchingTags(state: State, errorFetchingTags: null | Error) {
    state.errorFetchingTags = errorFetchingTags;
  }
};

export default mutations;
